import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["year", "month", "day"]

  connect() {
    this.updateMonths()
    this.updateDays()
  }

  yearChanged() {
    this.updateMonths()
    this.updateDays()
  }

  monthChanged() {
    this.updateDays()
  }

  updateMonths() {
    const year = parseInt(this.yearTarget.value)
    const today = new Date()
    let maxMonth = 12
    if (year === today.getFullYear()) {
      maxMonth = today.getMonth() + 1
    }
    const currentMonth = parseInt(this.monthTarget.value)
    this.monthTarget.innerHTML = ""
    for (let m = 1; m <= maxMonth; m++) {
      const option = document.createElement("option")
      option.value = m
      option.text = `${m} 月`
      if (m === currentMonth) option.selected = true
      this.monthTarget.appendChild(option)
    }
    // 若当前选中月超出范围，重置为最大可选月
    if (currentMonth > maxMonth) this.monthTarget.value = maxMonth
  }

  updateDays() {
    const year = parseInt(this.yearTarget.value)
    const month = parseInt(this.monthTarget.value)
    const today = new Date()
    let days

    if (year === today.getFullYear() && month === today.getMonth() + 1) {
      days = today.getDate() - 1
    } else {
      days = new Date(year, month, 0).getDate()
    }

    const currentDay = parseInt(this.dayTarget.value)
    this.dayTarget.innerHTML = ""
    for (let d = 1; d <= days; d++) {
      const option = document.createElement("option")
      option.value = d
      option.text = `${d} 日`
      if (d === currentDay) option.selected = true
      this.dayTarget.appendChild(option)
    }
    if (currentDay > days) this.dayTarget.value = days
  }
}
